import { useContext } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import { useSnackbar, OptionsObject } from 'notistack';
import { authContext } from 'helpers/services';


let AxiosHandlerProvider = () => {
    let history = useHistory();
    let { enqueueSnackbar } = useSnackbar();

    let authService = useContext(authContext);

    axios.interceptors.request.use(async config => {
        if (config.headers) {
            let token = await authService.getToken();
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    })

    axios.interceptors.response.use(
        response => response,

        error => {
            let { data, status } = error.response;


            let options: OptionsObject = {
                variant: 'error',
                autoHideDuration: 4000
            }

            switch (status) {
                case 400:
                    if (data.HasErrors) {
                        data.Errors.forEach((er: string) => {
                            enqueueSnackbar(er, options);
                        })
                    } else {
                        for (let i in data.errors)
                            enqueueSnackbar(data.errors[i], options);
                    }
                    break;

                case 401:
                    history.push('/error401');
                    break;

                case 500:
                    enqueueSnackbar('Internal server error', options);
                    break;

                default:
                    enqueueSnackbar('Unable to connect to server, please check your internet connection and retry.', options);
                    break;
            }

            return Promise.reject({ ...data });
        }
    )

    return (null);
}

export default AxiosHandlerProvider;